// extracted by mini-css-extract-plugin
export default {"container":"container-CPmqSzVqxg8f","item1":"item1-st4ik5ne_fHz","bgtitle":"bgtitle-ZxtEwOxxS61p","bgsize":"bgsize-pueEnaTf_SDO","preview":"preview-gyxI5WTzp0N2"};